import { Component, h } from 'preact';
import CSSModules from 'react-css-modules';
import ClassNames from 'classnames';
import styles from '../../css/app.css';
import ReactMarkdown from 'react-markdown';
import { SendGAPageView } from '../../utils-and-data/utils.js';

class SimpleTextPages extends Component {
  componentDidMount() { 
    SendGAPageView({
      title: this.props.title,
      path: this.props.path
    });
  }

  render() {
    return (
      <div styleName='simple-text-pages'>
        <h1>{this.props.title}</h1>
        {this.props.paragraphs.map((text,i) => {
          return <ReactMarkdown source={text} />
        })}
      </div>
    )
  }
}

// Apply 'react-css-modules' to this react component:
export default CSSModules(SimpleTextPages, styles);



// WEBPACK FOOTER //
// ./app/frontend/components/routes/simple-text-pages.jsx